var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1816",
    "data-name": "Group 1816",
    transform: "translate(-276.236 -418)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_",
    fill: "#4e4e57",
    "data-name": "!",
    fontFamily: "OpenSansHebrew-Bold, Open Sans Hebrew",
    fontSize: "11px",
    fontWeight: 700,
    transform: "translate(285 430)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -3.147,
    y: 0
  }, "!")), /*#__PURE__*/React.createElement("g", {
    id: "Path_6679",
    fill: "none",
    stroke: "none",
    "data-name": "Path 6679"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.236-.2a7 7 0 1 1-7 7 7 7 0 0 1 7-7z",
    transform: "translate(276 419)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4e4e57",
    d: "M7.236.798c-3.309 0-6 2.691-6 6 0 3.308 2.691 6 6 6 3.308 0 6-2.692 6-6 0-3.309-2.692-6-6-6m0-1c3.866 0 7 3.134 7 7s-3.134 7-7 7-7-3.134-7-7 3.134-7 7-7z",
    transform: "translate(276 419)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMark);
export default __webpack_public_path__ + "static/media/mark.0f430274cd62568318e1be8957ac64d1.svg";
export { ForwardRef as ReactComponent };